import { Modal as ModalModule } from 'common';
import React from 'react';

const { Modal } = ModalModule;

const promoLink = 'https://www.stamps.com/promo-codes/';

export const TermsModal = ({ modalId }) => (
	<Modal
		modalId={modalId}
		className="account-refer-a-friend account-terms-modal"
		header="Refer a Friend Terms and Conditions"
		size="large"
		hideFooter
	>
		<div>
			<ol>
				<li>
					<b>Acceptance of Terms &amp; Conditions.</b> By participating in the
					Tell a Friend Program (the "Program"), you accept and agree to be
					bound by, without limitation or qualification, the Stamps.com service{' '}
					<a
						href="https://www.stamps.com/conditions/"
						target="_blank"
						rel="noreferrer noopener"
					>
						Terms and Conditions
					</a>
					, these Tell a Friend Terms &amp; Conditions (the "TF Terms"), and any
					modifications or updates to either agreement. Stamps.com reserves the
					right, in its sole discretion, to discontinue or modify the Program at
					any time and for any duration, and without notice. You should
					therefore check these TF Terms for any changes prior to making a
					referral.
				</li>
				<li>
					<b>Program Description.</b> Subject to these TF Terms &amp;
					Conditions, Stamps.com will reward you in accordance with your
					applicable promotion (for example, a $20 credit or such other
					promotion provided in your Program offer) for each customer that you
					refer, signs up for the applicable Stamps.com Service, stays beyond
					the trial period for ninety days and is successfully billed for such
					period (each, a “Successful Referral”). Notwithstanding anything else
					in this agreement to the contrary, you are only eligible for one
					Reward per each Successful Referral.
				</li>
				<li>
					<b>Persons Who May Be Referred (Anti-Spamming).</b> Stamps.com does
					not tolerate the sending of unsolicited commercial email (“spam”). You
					may refer only persons with whom you have an established personal or
					business relationship and who you believe would be interested in
					opening a Stamps.com account. Without limiting the foregoing, you must
					not obtain names for referral from group email addresses or email
					mailing lists or by posting on social media platforms, websites or
					other bulletin/message boards. Violation of this Section 5 will result
					in the immediate termination of your participation in the Program and
					your forfeiture of any pending Rewards and/or Rewards previously
					awarded.
				</li>
				<li>
					<b>Eligibility For Receipt of Reward.</b> In addition to all the other
					requirements of the TF Terms, you will be eligible to receive a Reward
					only if you and your Referred Customer comply with all of the
					following conditions.
					<ul>
						<li>
							You must be an existing Stamps.com customer with a Stamps.com
							account in good standing at both the time that you make the
							referral and at the time the Reward is awarded.
						</li>
						<li>
							Your Referred Customer must have entered your unique Promo Code in
							the designated Program website referral page. You are only
							eligible to use one (1) Promo Code. If you attempt to receive
							Rewards using multiple Promo Codes you will be subject to
							immediate termination of your participation in the Program and
							your forfeiture of any pending Rewards and/or Rewards previously
							awarded. You may request your unique Promo Code by accessing the
							Tell-A-Friend program through your Stamps.com account.
						</li>
						<li>You may not refer yourself.</li>
						<li>
							You may not refer any person who is already a Stamps.com customer.
						</li>
						<li>
							You may only receive one Reward for each Referred Customer. This
							means, for example, that you are prohibited from the following
							sequence of actions: you provide a Referred Customer, you receive
							a Reward for that Referred Customer, that Referred Customer
							cancels service and then you provide that same Referred Customer
							again in an attempt to receive another Reward.
						</li>
						<li>
							Each individual Referred Customer will make his/her referrer
							eligible for one Reward only, regardless of the number of accounts
							he/she establishes with Stamps.com or the number of names he/she
							uses. A Referred Customer cannot be referred by more than one
							person. In the event that a Referred Customer is referred by more
							than one person, the person making the earlier referral will be
							eligible for the Reward.
						</li>
						<li>
							Each individual participating in the Program may only be deemed a
							single Stamps.com customer. Any person found to be creating or
							referring multiple accounts under the same or different names of a
							single individual will be disqualified from the program, will be
							ineligible for the Reward, and will result in the immediate
							termination of your participation in the Program and your
							forfeiture of any pending Rewards and/or Rewards previously
							awarded.
						</li>
						<li>
							Each Referred Customer must be a new customer who registers with
							Stamps.com for the Stamps.com service using a unique credit card
							number, electronic mail address and name not previously received
							by Stamps.com. Under no circumstances may you use your own credit
							card as the billing method for the Referred Customer. Any person
							found to be creating or referring accounts in the Program that
							utilize their own credit card as the billing method for the
							Referred Customer will be disqualified from the Program, will be
							ineligible for the Reward, may have future and/or
							previously-awarded Rewards forfeited, and may be immediately
							terminated from the Program.
						</li>
						<li>
							Employees of Stamps.com, its affiliates, subsidiaries, and vendors
							are not eligible to participate in the Tell-A-Friend program.
						</li>
					</ul>{' '}
					Stamps.com’s decisions as to compliance with Program requirements and
					operation are final.
				</li>
				<li>
					<b>Reward Type Details.</b> Postage Credits: For each Successful
					Referral under the postage credit Program, the applicable rewards or
					credits will be provided within 90 days. Credits are not transferable
					and are not redeemable for cash. Unused Credits currently do not
					expire, however, Stamps.com reserves the right in its sole discretion
					to have any unused Credits or other free postage credits expire if not
					used within certain timeframes. The policy governing expiration of
					unused Credits and other free postage may be changed at any time. If
					you cancel your account, and there are any Credits or a balance of
					unused free postage remaining in your account at the time, you forfeit
					the unused free postage. Unused postage that was purchased by you will
					be refunded pursuant to the Stamps.com Terms and Conditions.
				</li>
				<li>
					<b>Program Modifications.</b> Stamps.com reserves the right, in its
					sole discretion, to modify, suspend or discontinue any part of the
					Program at any time, including the availability of any Program
					feature, with or without notice to you. Stamps.com also reserves the
					right, in its sole discretion, to impose limits on certain features
					and to restrict access to any part or to all of the Program without
					notice to you. Stamps.com shall not be liable to you or any third
					party for any claim or cause of action arising out of Stamps.com’s
					exercise of the foregoing rights.
				</li>
				<li>
					<b>Abuses.</b> If Stamps.com determines, in its sole discretion, that
					you have not complied with these Terms &amp; Conditions or have
					otherwise abused the Program in any way, it may, in addition to any
					other rights and remedies it may have against you, immediately and
					without notice to you, terminate or suspend your participation in the
					Program and withdraw all Credits issued or to be issued to you.
					Stamps.com shall not be liable to you or to any third party for any
					claim or cause of action arising out of such termination or
					suspension.
				</li>
				<li>
					<b>Limitation of Liability &amp; Disclaimer of Warranties.</b> While
					Stamps.com uses its best efforts to maintain the accuracy and
					reliability of its website and the Program, it does not warrant or
					represent that the website or Program will always function or be
					error-free. Stamps.com assumes no liability or responsibility for
					errors or omissions in the Program or for the deletion of or failure
					to store transaction records. Your access and use of the Stamps.com
					website and Program are at your own risk. IN ADDITION TO THE
					LIMITATIONS OF LIABILITY SET FORTH IN THE STAMPS.COM TERMS AND
					CONDITIONS, STAMPS.COM SHALL NOT BE LIABLE FOR ANY DIRECT, INDIRECT,
					INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES ARISING OUT OF
					YOUR ACCESS TO, USE OF OR INABILITY TO USE THE PROGRAM, THE LOSS OF
					DATA OR THE RECEIPT OR USE OF ANY FREE POSTAGE OR OTHER ITEMS AWARDED
					THROUGH THE PROGRAM. WITHOUT LIMITING THE FOREGOING, THE PROGRAM IS
					PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS, WITHOUT WARRANTY OF
					ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
					IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
					PURPOSE AND NON-INFRINGEMENT. Some jurisdictions do not allow the
					exclusion of certain warranties, so some of the above exclusions may
					not apply to you. Neither Stamps.com nor any other party involved in
					creating, producing, maintaining or delivering the Program shall be
					liable for any damages to or viruses that may infect your computer
					equipment or other property on account of your access to or use of the
					Stamps.com website or Program.
				</li>
				<li>
					<b>Privacy.</b> Please refer to the Stamps.com Privacy Policy for
					further details on how we use the information we collect from you.
				</li>
				<li>
					<b>Other Terms.</b> The Stamps.com Terms and Conditions govern all
					matters not specifically set forth herein, including, but not limited
					to, Dispute Resolution; Agreement To Arbitrate; And Class Waiver.
				</li>
			</ol>
		</div>
	</Modal>
);
